<!--<app-dp-detail-info [title]="'Dealer Information'">-->
<div class="d-flex justify-content-between">
  <legend class="h3 mb-16px">Dealer Information</legend>
  <font-awesome
    (click)="changeView.emit(true)"
    *ngIf="[companies.Sea].includes(company)"
    [icon]="'fa-light fa-grid-2 btn-cursor'"
  ></font-awesome>
</div>
<div class="detail-container">
  <div class="row">
    <div class="col-1 detail-label">Name</div>
    <div class="col-3 detail-value">{{ dealerDetail.name }}</div>
    <div class="col-2 detail-label">Status</div>
    <div class="col-2 detail-value">
      <dp-badge [color]="'#2E81E8FF'" [size]="'wd-xxs'" [text]="dealerDetail.status"></dp-badge>
    </div>
    <div *ngIf="isAdmin" class="col-1 detail-label">BP#</div>
    <div *ngIf="isAdmin" class="col-3 detail-value">
      {{ dealerDetail.bpNo }}
    </div>
  </div>
  <div *ngIf="isAdmin && [companies.Sea, companies.Seca].includes(company)" class="row">
    <div class="col-1 detail-label">HQ</div>
    <div class="col-3 detail-value">
      {{ dealerDetail.hq | booleanToString }}
    </div>
    <div *ngIf="!dealerDetail.hq" class="col-2 detail-label">HQ BP#</div>
    <div *ngIf="!dealerDetail.hq" class="col-2 detail-value">
      {{ dealerDetail.hqBpNo }}
    </div>
    <div *ngIf="dealerDetail.hq" class="col-2 detail-label">Purchase Place</div>
    <div *ngIf="dealerDetail.hq" class="col-2 detail-value">
      {{
        dealerDetail.purchasePlaceCode
          ? '['.concat(dealerDetail.purchasePlaceCode).concat('] ').concat(dealerDetail.purchasePlaceName)
          : ''
      }}
    </div>
  </div>
  <div class="row">
    <div class="col-1 detail-label">Address</div>
    <div class="col-7 detail-value">{{ dealerDetail.address.address1 }}</div>
    <div class="col-1 detail-label">Address2</div>
    <div class="col-3 detail-value">{{ dealerDetail.address.address2 }}</div>
  </div>
  <div class="row">
    <div class="col-1 detail-label">City</div>
    <div class="col-3 detail-value">{{ dealerDetail.address.city }}</div>
    <div class="col-2 detail-label">State</div>
    <div class="col-2 detail-value">{{ dealerDetail.address.state }}</div>
    <div class="col-1 detail-label">Postal Code</div>
    <div class="col-3 detail-value">{{ dealerDetail.address.zipcode }}</div>
  </div>
  <div class="row">
    <div class="col-1 detail-label">Phone #</div>
    <div class="col-3 detail-value">{{ dealerDetail.tel | telNoCountry }}</div>
    <div class="col-2 detail-label">Email</div>
    <div class="col-3 detail-value">{{ dealerDetail.email }}</div>
    <div class="col-2 detail-value"></div>
    <div *ngIf="isEditable && dealerDetail.status === 'ACTIVE' && !isAdminViewerRole" class="col-1">
      <button (click)="modalOpen()" *ngIf="showNew" class="btn btn-dark" type="button">
        <font-awesome>Edit</font-awesome>
      </button>
    </div>
  </div>
</div>

<div class="mb-24px"></div>
<div *ngIf="isContactManage" class="d-flex flex-row justify-content-between">
  <ul class="nav nav-pills" id="pills-tab" role="tablist">
    <li (click)="showSubItem('CONTACT')" class="nav-item" role="presentation">
      <button
        [ngClass]="{
          'tab-btn-active': this.view === 'CONTACT',
          'tab-btn-inactive': this.view === 'LOCATION' || this.view === 'ACTIVITY_SUMMARY'
        }"
        id="ContactInformationTab"
        role="tab"
        type="button"
      >
        Contact Information
      </button>
    </li>
    <li
      (click)="showSubItem('LOCATION')"
      *ngIf="
        [
          concealedType.SAMSUNG_INSPECTION.code,
          concealedType.SELF_SAMSUNG.code,
          concealedType.SELF_INSPECTION.code
        ].includes(dealerDetail.concealedDamageType) && isAdmin
      "
      class="nav-item"
      role="presentation"
    >
      <button
        [ngClass]="{
          'tab-btn-active': this.view === 'LOCATION',
          'tab-btn-inactive': this.view === 'CONTACT' || this.view === 'ACTIVITY_SUMMARY'
        }"
        id="LocationAliasTab"
        role="tab"
        type="button"
      >
        Location Alias
      </button>
    </li>
    <li
      (click)="showSubItem('ACTIVITY_SUMMARY')"
      *ngIf="isAdmin"
      class="nav-item"
      role="presentation"
    >
      <button
        [ngClass]="{
          'tab-btn-active': this.view === 'ACTIVITY_SUMMARY',
          'tab-btn-inactive': this.view === 'CONTACT' || this.view === 'LOCATION'
        }"
        id="ActivitySummaryTab"
        role="tab"
        type="button"
      >
        Activity Summary
      </button>
    </li>
  </ul>
  <button
    (click)="openPopup(this.view)"
    *ngIf="isEditable && dealerDetail.status === 'ACTIVE' && !isAdminViewerRole && view !== 'ACTIVITY_SUMMARY'"
    class="btn btn-dark button-small"
    type="button"
  >
    Add
  </button>
</div>

<div *ngIf="isContactManage && view === 'CONTACT'" class="d-list">
  <div class="h-100 w-100 d-flex flex-column">
    <div #listContainer class="dealer-table-wrapper w-100" style="position: absolute">
      <perfect-scrollbar>
        <table class="table table-list align-middle table-nowrap w-100">
          <thead>
            <tr>
              <th>No.</th>
              <th [attr.data-sort-fields]="'firstName'">First Name</th>
              <th [attr.data-sort-fields]="'lastName'">Last Name</th>
              <th [attr.data-sort-fields]="'tel'">Phone #</th>
              <th [attr.data-sort-fields]="'email'">Email</th>
              <th></th>
            </tr>
          </thead>
          <tbody class="assigned-dealers">
            <tr *ngFor="let i = index; let dealerContact; of: dealerContacts">
              <td>{{ i + 1 }}</td>
              <td>{{ dealerContact.firstName }}</td>
              <td>{{ dealerContact.lastName }}</td>
              <td>{{ dealerContact.tel | tel }}{{ dealerContact.ext ? ',  Ext.: '.concat(dealerContact.ext) : '' }}</td>
              <td>{{ dealerContact.email }}</td>
              <td>
                <div *ngIf="isContactManage && dealerDetail.status === 'ACTIVE'" class="button-container">
                  <button
                    (click)="deleteContact(dealerDetail.bpNo, dealerContact._id)"
                    *ngIf="user.username !== dealerContact.email && !isDealerStaff && !isAdminViewerRole"
                    class="btn btn-light button-small"
                    type="button"
                  >
                    Delete
                  </button>
                  <div style="width: 10px"></div>
                  <button
                    (click)="openContact(dealerContact)"
                    *ngIf="!isDealerStaff && !isAdminViewerRole"
                    class="btn btn-dark button-small"
                    type="button"
                  >
                    Edit
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </perfect-scrollbar>
    </div>
    <div *ngIf="!dealerDetail.contacts?.length" class="align-center">
      <font-awesome [icon]="'fa-light fa-file-circle-exclamation'"></font-awesome>
      <span class="pl-14px">No dealer contact</span>
    </div>
  </div>
</div>
<div *ngIf="isContactManage && view === 'LOCATION' && isAdmin" class="d-list">
  <div class="h-100 w-100 d-flex flex-column">
    <div class="dealer-table-wrapper w-100" style="position: absolute">
      <perfect-scrollbar>
        <table class="table table-list align-middle table-nowrap w-100">
          <thead>
            <tr>
              <th>No.</th>
              <th>Location Alias</th>
              <th>State</th>
              <th>City</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th></th>
            </tr>
          </thead>
          <tbody class="assigned-dealers">
            <tr *ngFor="let i = index; let locationAlias; of: dealerDetail.locationAliases">
              <td>{{ i + 1 }}</td>
              <td>{{ locationAlias.locationAlias }}</td>
              <td>{{ locationAlias.address.state }}</td>
              <td>{{ locationAlias.address.city }}</td>
              <td>{{ locationAlias.firstName }}</td>
              <td>{{ locationAlias.lastName }}</td>
              <td>{{ locationAlias.email }}</td>
              <td>
                <div class="button-container">
                  <button
                    (click)="deleteLocationAlias(dealerDetail.bpNo, locationAlias._id)"
                    class="btn btn-light button-small"
                    type="button"
                  >
                    Delete
                  </button>
                  <button (click)="openAlias(locationAlias)" class="btn btn-dark button-small ml-12px" type="button">
                    Edit
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </perfect-scrollbar>
    </div>
    <div *ngIf="!dealerDetail.locationAliases?.length" class="align-center">
      <font-awesome [icon]="'fa-light fa-file-circle-exclamation'"></font-awesome>
      <span class="pl-14px">No location alias</span>
    </div>
  </div>
</div>

<div *ngIf="isContactManage && view === 'ACTIVITY_SUMMARY' && isAdmin" class="d-list">
  <app-user-activity-summary-section
    [userInfo]="userDetails"
    [isDealer]="true"
    [isHq]="dealerDetail.hq"
  ></app-user-activity-summary-section>
</div>
